import React, { useState } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { SpinfitHero } from "@/components/SpinfitHero";
import { Equipment } from "@/components/Equipment";
import { Classes } from "@/components/Classes";
import { Reto5 } from "@/components/Reto5";
import { Pricing } from "@/components/Pricing";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { JoinModal } from "@/components/JoinModal";

export default function Landing() {
  const [joinOpen, setJoinOpen] = useState(false);
  return (
    <div className="App bg-black">
      <Header onJoin={() => setJoinOpen(true)} />
      <Hero onJoin={() => setJoinOpen(true)} />
      <SpinfitHero />
      <Equipment />
      <Classes />
      <Reto5 />
      <Pricing />
      <Contact />
      <Footer />
      <JoinModal open={joinOpen} onOpenChange={setJoinOpen} />
    </div>
  );
}
